export default __webpack_public_path__ + "static/media/ello.5c9d5a7e.svg";